<template>
  <kst-container class="kst-item-export-details">
    <kst-form
      :failure="failureList"
      :failureInit="failureInit"
      :hide-body="!!formWarnings"
      :hide-footer="!!formWarnings"
      :title="title"
      :warnings="formWarnings"
    >
      <Export
        ref="refExport"
        :access="access"
        :searchData="searchData"
        @error="handleError"
      />

      <kst-section export-mode>
        <kst-check disabled v-model="searchData.WithItem" :label="labelOptItem"/>
        <kst-check v-model="searchData.WithDispatch" :label="labelOptDispatch"/>
        <kst-check v-model="searchData.WithStock" :label="labelOptStock"/>
      </kst-section>

      <template #bottom-left>
        <kst-button action-mode
          class="is-primary"
          tag="button"
          :module="Model.Module"
          :moduleType="Model.ModuleType.ExportList"
          @click="handleExport"
        />
      </template>
    </kst-form>
  </kst-container>
</template>

<script>
import AxiosMixin from "@/mixins/AxiosMixin.js";
import RouterMixin from "@/mixins/RouterMixin.js";
import Info from "../ItemInfo.js";
import Model from "../ItemModel.js";
import Services from "../ItemServices.js";

import Export from "./ItemExportDetails_Details";

export default {
  mixins: [AxiosMixin, RouterMixin],
  components: {
    Export
  },
  data: () => ({
    Model: Model,
    searchData: {
      WithDispatch: true,
      WithItem: true,
      WithStock: true
    },
    access: {},
    id: null,
    items: [],
    isListLoading: true,
    // error
    failureInit: null,
    failureList: null,
    formWarnings: null
  }),
  computed: {
    labelOptDispatch() {
      return Info.Export.Details.Excel.Option.Dispatch;
    },
    labelOptItem() {
      return Info.Export.Details.Excel.Option.Item;
    },
    labelOptStock() {
      return Info.Export.Details.Excel.Option.Stock;
    },
    title() {
      return Info.Export.Details.Excel.Title;
    }
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      this.id = this.getUrlParam(this.$kst.Enum.Param.ID);
      this.formWarnings = null;

      if (!this.id) {
        this.formWarnings = [Info.Message.Details_ParamIncomplete];
        return;
      }

      this.access = Model.createAccess();
      this.initLoad();
    },
    initLoad() {
      this.isLoading = true;
      this.failureInit = null;

      this.loadDetailsData();
    },
    initLoad_End() {
      this.isLoading = false;
    },

    loadDetailsData() {
      const config = Services.getItemDetailsData(this.id, { withoutdetails: 1 });
      this.runAxios(config, null,
        this.loadDetailsData_Success,
        this.loadDetailsData_Error,
        this.loadDetailsData_Invalid
      );
    },
    loadDetailsData_Success(data) {
      this.access = data.Access;
      this.initLoad_End();
    },
    loadDetailsData_Error(message) {
      this.failureInit = message;
      this.initLoad_End();
    },
    loadDetailsData_Invalid(message) {
      this.formWarnings = [message];
      this.initLoad_End();
    },

    handleError(message) {
      this.failureList = message;
    },
    handleExport() {
      this.failureList = null;
      this.$refs.refExport.exportExcel(this.id);
    }
  }
}
</script>